module.exports = __webpack_public_path__ + "img/wuhantiyuLogo.3bfb7411.png";